module.exports = __webpack_public_path__ + "img/shengnuo.277ac71b.png";